import {useSignal, useSignals} from '@preact/signals-react/runtime'
import {InputMask} from 'primereact/inputmask'
import {forwardRef, useImperativeHandle, useMemo} from 'react'

const StyledInputMask = forwardRef(
    (
        {
            key = '',
            value = null,
            placeholder = '',
            onChange = () => {},
            className = '',
            ...restProps
        },
        ref,
    ) => {
        useSignals()

        useImperativeHandle(ref, () => ({
            getValue: () => handleGetValue(),
            changeValue: newValue => handleChangeValue(newValue),
        }))

        const initialValue = useMemo(() => {
            return value || null
        }, [value])

        //#region Local State
        const selectedValue = useSignal(initialValue)

        const handleGetValue = () => {
            return selectedValue.peek()
        }

        const handleChangeValue = newValue => {
            selectedValue.value = newValue
        }
        //#endregion

        return (
            <div id="styled-input-text">
                <InputMask
                    className={`w-full h-3rem  prevent-select ${className}`}
                    style={{fontSize: '14px'}}
                    mask="99-99-9999"
                    slotChar="DD-MM-YYYY"
                    value={selectedValue.value || ''}
                    onFocus={e => {
                        e.target.setSelectionRange(0, 0)
                    }}
                    onChange={e => {
                        let newValue = e.target.value

                        if (onChange) {
                            onChange(newValue)
                        }

                        selectedValue.value = newValue
                    }}
                    placeholder={placeholder}
                    {...restProps}
                />
            </div>
        )
    },
)

export default StyledInputMask
